import React, { FC, useEffect, useState } from "react";
import { usePagination } from "../../contexts/table/PaginationContext";
import List from "../list/list";
import Paginator from "../paginator/paginator";
import SearchField from "../search-field/search-field";
import { DEF_PG_SIZE_DROP_DOWN } from '../../constants/maximum-page-size';
import "./searchable-list.css";

type Props = {
    items: any[];
    title: string;
    onSelect: (index: number, item: any) => void;
    isStriped?: boolean;
    isMultiSelect?: boolean;
    selectedItems?: number[];
    searchBoxClassName?: string;
    titleClassName?: string;
    listClassName?: string;
    stripedListClassName?: string;
    listItemClassName?: string;
    stripedListItemClassName?: string;
    selectedListItemClassName?: string;
    onSearch?: (searchTerm) => void;
    pageSizeSet?: number[];
    searchable?: boolean;
};

/**
 *
 * @param param0
 * @returns
 */
const PaginatedSearchableList: FC<Props> = ({
    items,
    title,
    onSelect,
    isStriped = true,
    isMultiSelect = false,
    selectedItems = new Array(0),
    searchBoxClassName = "mx-2 p-1",
    titleClassName = "mx-2 mt-2 p-1",
    listClassName = "pt-1 pr-1 pl-1",
    stripedListClassName = "p-1",
    listItemClassName,
    stripedListItemClassName,
    selectedListItemClassName,
    onSearch = (searchTerm: string) => {}, //default to search inside the component.
    pageSizeSet = [DEF_PG_SIZE_DROP_DOWN],
}) => {
    const [listItems, setListItems] = useState(new Array(0));
    const paginationContext = usePagination();

    const buildListItem = (item, index) => {
        return { value: item, isSelected: selectedItems.includes(index) };
    };

    const buildListItems = (items) => {
        if (!!items) {
            return items.map(buildListItem);
        }
        return items;
    }

    useEffect(() => {
        setListItems(buildListItems(items));
    }, [items]);

    useEffect(() => {
        setListItems(buildListItems(items));
    }, [selectedItems]);

    useEffect(() => {
        if (!!items) {
            const newItems = items.map(buildListItem);
            setListItems(newItems);
        }
    }, []);

    return (
        <>
            <SearchField
                setSearchTerm={onSearch}
                className={searchBoxClassName}>
            </SearchField>
            <div className={`flex flex-row border text-gray-700 rounded-t ${titleClassName}`}>
                <p className="p-1 text-gray-700 text-xs font-bold">
                    {title}
                </p>
            </div>
            <Paginator
                itemCount={listItems.length}
                onPageNumberUpdated={paginationContext.updatePageNumber}
                paginationObj={paginationContext.pagination}
                sizes={pageSizeSet}>
                {({ start, end }) =>
                    <div
                        className={isStriped
                            ? `text-gray-700 ${stripedListClassName}`
                            : `text-black ${listClassName}`}>
                        <List
                            onSelect={(index, item) => onSelect(index, item)}
                            isStriped={isStriped}
                            items={listItems}
                            isMultiSelect={isMultiSelect}
                            listItemClassName={listItemClassName}
                            stripedListItemClassName={stripedListItemClassName}
                            selectedListItemClassName={selectedListItemClassName}>
                        </List>
                    </div>
                }
            </Paginator>
        </>
    );
};

export default PaginatedSearchableList;
